/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1LockIcon16Solid = forwardRef('People1LockIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M7.001 9.034c.551-.04.999.414.999.966v3a1 1 0 0 1-1 1H3.4c-.773 0-1.425-.637-1.263-1.393.6-2.805 3.044-3.44 4.864-3.573Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 11.058V10.5a2.5 2.5 0 0 1 5 0v.558a1.4 1.4 0 0 1 1 1.342v2.2a1.4 1.4 0 0 1-1.4 1.4h-4.2A1.4 1.4 0 0 1 9 14.6v-2.2a1.4 1.4 0 0 1 1-1.342ZM13.5 11h-2v-.5a1 1 0 1 1 2 0v.5Z" })));
});
